export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";
export const RESULT_MODAL = "RESULT_MODAL";
export const LOAD_MODAL_OBJECT_SUCCESS = "LOAD_MODAL_OBJECT_SUCCESS";
export const LOAD_MODAL_OBJECT_START = "LOAD_MODAL_OBJECT_START";
export const CONFIRM_DIALOG = "CONFIRM_DIALOG";
export const ASK_NUMBER = "ASK_NUMBER";
